<template>
  <el-dialog
    title="离线视频解析任务创建"
    v-model="flag"
    width="30%"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="formRef"
        :model="tableParams"
        :rules="rules"
        :disabled="disabled"
        size="small"
        label-position="left"
      >
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="tableParams.taskName" />
        </el-form-item>
        <el-form-item label="离线视频" prop="sources">
          <el-button type="primary" @click="zyxzselect">+选择</el-button>
        </el-form-item>
        <div class="content_table">
          <div
            style="margin-bottom: 20px"
            v-for="sources in tableParams.sources"
            :key="sources"
          >
            {{ sources.sourceName }}
          </div>
        </div>
        <el-form-item label="解析目标">
          <el-checkbox
            :true-label="1"
            :false-label="-1"
            v-model="tableParams.face"
            label="人脸"
            :name="1"
          />
          <el-checkbox
            :true-label="1"
            :false-label="-1"
            v-model="tableParams.person"
            label="人体"
            :name="1"
          />
          <el-checkbox
            :true-label="1"
            :false-label="-1"
            v-model="tableParams.vehicle"
            label="机动车"
            :name="1"
          />
          <el-checkbox
            :true-label="1"
            :false-label="-1"
            v-model="tableParams.nonvehicle"
            label="非机动车"
            :name="1"
          />
        </el-form-item>
        <el-form-item label="分析倍数" prop="speed">
          <el-input v-model="tableParams.speed" class="hashrate" />
          <p>
            剩余算力/总算力:{{ slObj.availablePower }}/{{ slObj.totalPower }}
          </p>
        </el-form-item>
        <el-form-item label="优先级" prop="priorityLevel">
          <el-radio v-model="tableParams.priorityLevel" :label="1"
            >紧急</el-radio
          >
          <el-radio v-model="tableParams.priorityLevel" :label="2"
            >常规</el-radio
          >
        </el-form-item>
        <el-form-item label="定时设置">
          <el-select
            @change="selectDssz()"
            v-model="tableParams.cronType"
            class="m-2"
            placeholder="无"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <br />
          <el-button
            type=""
            @click="addClick()"
            v-if="tableParams.cronType !== ''"
            >添加</el-button
          >
        </el-form-item>
      </el-form>

      <el-row
        style="margin-top: 10px"
        v-for="(item, index) in tableParams.timesResps"
        :key="index"
      >
        <el-row>
          <el-col :span="24" v-if="tableParams.cronType === '4'">
            <el-date-picker
              v-model="tableParams.startTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-col :span="2"></el-col>
        <el-col
          :span="6"
          v-if="
            tableParams.cronType === '2' ||
            tableParams.cronType === '3' ||
            tableParams.cronType === '1'
          "
        >
          <el-time-select
            v-model="item.startTime"
            start="0:0"
            step="01:00"
            end="24:00"
          ></el-time-select>
        </el-col>
        <el-col
          style="margin-left: 10px"
          :span="6"
          v-if="
            tableParams.cronType === '2' ||
            tableParams.cronType === '3' ||
            tableParams.cronType === '1'
          "
        >
          <el-time-select
            v-model="item.endTime"
            start="0:0"
            step="01:00"
            end="24:00"
          ></el-time-select>
        </el-col>
        <el-col
          :span="24"
          v-if="tableParams.cronType === '2' || tableParams.cronType === '3'"
        >
          <div class="zyclass">
            <div
              :class="{ zyclassHover: item.days.includes(items) }"
              v-for="items in tableParams.cronType === '2' ? 7 : 31"
              :key="items"
              @click="hoverClick(item.days, items)"
            >
              {{ tableParams.cronType === "2" ? zhouList[items] : items }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button
          type="primary"
          v-if="!rowItem.id"
          @click="emitCheckList(formRef)"
          >确定</h-button
        >
        <h-button type="primary" @click="close">取消</h-button>
        <!-- <h-button @click=" = false">取消</h-button> -->
      </span>
    </template>
  </el-dialog>
  <newlyadd
    @selectList="selectList"
    @clone="flag1 = false"
    v-model="flag1"
  ></newlyadd>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, watchEffect } from "vue";
import newlyadd from "@/views/smartApplication/videoAnalysis/components/newlyadd.vue";
import {
  aixresources,
  tasksid,
  tasks,
} from "@/api/videoAnalysis/videoAnalysisApi.js";

import { ElMessage } from "element-plus";
export default defineComponent({
  components: {
    newlyadd,
  },
  props: {
    rowItem: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const formRef = ref(null);

    const state = reactive({
      flag: false,
      disabled: false,
      timeDate: "",
      flag1: false,
      zhouList: ["", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      HoverIndex: [1],
      slObj: {},
      options: [
        {
          label: "无",
          value: "",
        },
        {
          label: "按日循环",
          value: "1",
        },
        {
          label: "按周循环",
          value: "2",
        },
        {
          label: "按月循环",
          value: "3",
        },
        {
          label: "不循环",
          value: "4",
        },
      ],
      tableParams: {
        taskName: "",
        face: 1,
        person: 1,
        vehicle: 1,
        nonvehicle: 1,
        speed: "1",
        timesResps: [
          {
            days: [],
            endTime: "",
            startTime: "",
          },
        ],
        //  {
        //   days: ""
        //   // endTime: "",
        //   // startTime: ""
        // },
        priorityLevel: 1,
        sources: [],
        sourceType: 4,
        cronType: "",
      },
      rules: {
        taskName: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur",
          },
        ],
        sources: [
          {
            required: true,
            message: "请选择离线视频",
            trigger: "blur",
          },
        ],
        speed: [
          {
            required: true,
            message: "请输入算力",
            trigger: "blur",
          },
        ],
      },
    });

    watchEffect(() => {
      state.flag = props.visible;
    });
    // 详情
    const diles = async (row) => {
      console.log(row, 66666666666);
      if (row) {
        const params = {
          id: row.id,
        };
        const res = await tasksid(params);
        state.tableParams = res.data;
        state.disabled = true;
      } else {
        state.disabled = false;
        state.tableParams = {
          taskName: "",
          face: 1,
          person: 1,
          vehicle: 1,
          nonvehicle: 1,
          speed: "1",
          timesResps: [
            {
              days: [],
              endTime: "",
              startTime: "",
            },
          ],
          //  {
          //   days: ""
          //   // endTime: "",
          //   // startTime: ""
          // },
          priorityLevel: 1,
          sources: [],
          sourceType: 4,
          cronType: "",
        };
      }
    };
    const zyxzselect = () => {
      state.flag1 = true;
    };
    const addClick = () => {
      state.tableParams.timesResps.push({
        days: [],
        endTime: "",
        startTime: "",
      });
    };
    const hoverClick = (item, index) => {
      if (item.indexOf(index) === -1) {
        item.push(index);
      } else {
        item.splice(item.indexOf(index), 1);
      }
    };
    const aixresourcesAxios = async () => {
      const res = await aixresources();
      state.slObj = res.data;
    };
    aixresourcesAxios();
    const selectList = (val) => {
      state.tableParams.sources = val.map((item) => {
        const obj = {};
        obj.cascadedId = "-1";
        obj.fileKey = item.fileKey;
        obj.sourceId = item.fileId;
        obj.sourceName = item.fileName;
        return obj;
      });
      state.tableParams.sources[0].cascadedId = -1;
      state.flag1 = false;
    };
    const selectDssz = () => {
      state.tableParams.timesResps = [
        {
          days: [],
          endTime: "",
          startTime: "",
        },
      ];
    };
    // 添加
    const emitCheckList = async (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const res = await tasks(state.tableParams);
          if (res.code == 0) {
            ElMessage.success("操作成功");
            context.emit("submit");
          }
          close();
        } else {
          return false;
        }
      });
    };
    //关闭弹窗
    const close = () => {
      context.emit("update:visible", false);
    };
    return {
      ...toRefs(state),
      selectDssz,
      diles,
      selectList,
      hoverClick,
      addClick,
      zyxzselect,
      formRef,
      emitCheckList,
      close,
    };
  },
});
</script>
<style scoped lang="scss">
.content {
  padding: 12px 40px 0px;
  .content_table {
    max-height: 200px;
    overflow: auto;
  }
}
.zyclass {
  display: flex;
  font-size: 12px;
  flex-wrap: wrap;
  padding: 0 50px;
  padding-top: 20px;
  div {
    text-align: center;
    line-height: 50px;
    width: 50px;
    height: 50px;
    border: 1px solid #dcdee3;
    border: 1px solid #dcdee3;
    cursor: pointer;
  }
}
.zyclassHover {
  color: #fff;
  background-color: #5584ff;
}
</style>
